// utils/axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://lime-otter-645901.hostingersite.com/api/v1", // Your backend base URL
  // baseURL: "http://localhost:8000/api/v1", // Your backend base URL
  withCredentials: true, // For cookies if you're using them
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // You can modify the config here (e.g., add auth token)
    const token = localStorage.getItem("adminToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

let isLoggingOut = false;

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle errors globally
    if (error.response?.status === 401 && !isLoggingOut) {
      isLoggingOut = true;

      // Token missing/invalid/expired — clear it so ProtectedRoute/PublicRoute
      // don't keep treating the session as authenticated and loop back to /app.
      localStorage.removeItem("adminToken");

      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      } else {
        isLoggingOut = false;
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
